import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectUserProfile } from '../../selectors/user';
import config from '../../config';

type SimplesatSurveyFn = (options: {
  survey_token: string;
  customer: {
    email: string;
    name: string;
  };
  [key: string]: any;
}) => void;

interface SimplesatModule {
  survey: SimplesatSurveyFn;
}

interface SimplesatWindow extends Window {
  simplesat?: SimplesatModule;
}

const SimplesatSurvey: React.FC = () => {
  const userProfile = useSelector(selectUserProfile);
  const { email, name } = userProfile || {};
  const initializedRef = useRef(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const scriptId = 'simplesat-web-embed';
    const existingScript = document.getElementById(scriptId);

    if (existingScript) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://cdn.simplesat.io/web-embed/web-embed-loader.js';
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = () => {
      console.error('Failed to load Simplesat survey script');
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!scriptLoaded) {
      return;
    }

    if (email && name && config.simplesatSurveyKey) {
      if (initializedRef.current) {
        return;
      }

      const typedWindow = window as SimplesatWindow;
      if (typedWindow.simplesat && typedWindow.simplesat.survey) {
        typedWindow.simplesat.survey({
          survey_token: config.simplesatSurveyKey,
          customer: { email, name },
        });

        initializedRef.current = true;
      }
    }
  }, [scriptLoaded, email, name]);

  return null;
};

export default SimplesatSurvey;
